import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 12,
    overflow: 'hidden',
  },
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(3, 3, 2),
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1.5),
    top: theme.spacing(1.5),
    color: theme.palette.text.secondary,
  },
  title: {
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.4,
    paddingRight: theme.spacing(5),
  },
  content: {
    padding: theme.spacing(0, 3, 2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  searchField: {
    flex: 1,
    minWidth: 0,
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 9999,
      backgroundColor: theme.palette.common.white,
      minHeight: 44,
      paddingLeft: theme.spacing(0.5),
      overflow: 'hidden',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
      borderRadius: 9999,
    },
    '& fieldset': {
      borderRadius: 9999,
    },
    '& .MuiOutlinedInput-input': {
      padding: theme.spacing(1.25, 1.5),
      fontSize: '0.875rem',
    },
    '& .MuiInputAdornment-root': {
      marginRight: theme.spacing(0.5),
      color: theme.palette.text.secondary,
    },
  },
  filterButton: {
    flexShrink: 0,
  },
  listHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBottom: 0,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
    '&.Mui-disabled': {
      cursor: 'default',
      opacity: 1,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  listHeaderText: {
    flex: 1,
    minWidth: 0,
    marginLeft: theme.spacing(0.5),
    '& .MuiListItemText-root': {
      margin: 0,
    },
  },
  contactRowText: {
    flex: 1,
    minWidth: 0,
    '& .MuiListItemText-root': {
      margin: 0,
    },
  },
  listHeaderLabel: {
    fontWeight: 400,
    fontSize: '0.875rem',
  },
  listHeaderDivider: {
    listStyle: 'none',
    backgroundColor: '#e0e0e0',
  },
  contactCheckbox: {
    flexShrink: 0,
    width: 40,
    height: 40,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.MuiCheckbox-root': {
      padding: 0,
    },
    '&.Mui-checked, &.MuiCheckbox-indeterminate': {
      color: '#0053ff',
    },
    '& .MuiSvgIcon-root': {
      fontFamily: '"Material Symbols Rounded Variable"',
      fontSize: 24,
      width: 24,
      height: 24,
    },
  },
  contactList: {
    maxHeight: 400,
    overflowY: 'auto',
    padding: 0,
    margin: theme.spacing(0, -3),
  },
  contactListItem: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: 0,
    '& .MuiListItemText-root': {
      margin: 0,
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  contactAvatar: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
  },
  emptyState: {
    padding: theme.spacing(2, 0, 3),
  },
  dialogActions: {
    justifyContent: 'flex-end',
    padding: theme.spacing(2, 3, 3),
    margin: 0,
    gap: theme.spacing(1),
  },
  createButton: {
    minWidth: 96,
  },
}))

export default useStyles
